<div class="price-mode-sidebar-container">
  <ion-header *ngIf="isMobile" class="ion-no-border ion-header-modal-desktop">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          (click)="closeSidebar.emit()"
          class="close-button"
          data-cy="close-sidebar-button"
        >
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <div class="price-mode-sidebar-header">
    <div class="header-left-side">
      <img
        class="product-image"
        src="{{ product?.imageThumbnail }}"
        (error)="
          this.product.imageThumbnail = getAlternativeThumbnail(
            product?.imageThumbnail
          )
        "
        *ngIf="product?.imageThumbnail"
        [attr.data-cy]="
          'price-mode-sidebar-product-' + product?.productNumber + '-image'
        "
      />
    </div>

    <div class="header-right-side">
      <div
        class="brand-name"
        [attr.data-cy]="
          'price-mode-sidebar-product-' + product?.productNumber + '-brand'
        "
      >
        {{ product?.summary?.brand }}
      </div>
      <div
        class="product-description"
        [attr.data-cy]="
          'price-mode-sidebar-product-' +
          product?.productNumber +
          '-description'
        "
      >
        {{ product?.summary?.productDescTxtl }}
      </div>
    </div>
  </div>

  <div class="header-details-section">
    <div
      class="product-details-header"
      (click)="productDetailsClick.emit()"
      [attr.data-cy]="
        'price-mode-sidebar-product-' + product?.productNumber + '-details'
      "
      style="flex: 1"
    >
      {{ 'i18n.lists.productDetails' | translate }}
    </div>

    <app-product-card-promotions-banner
      *ngIf="product?.promotionDetails?.offerBenefitDesc"
      class="promotions-banner"
      [productNumber]="product?.productNumber"
      [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
      [attr.data-cy]="
        'price-mode-sidebar-product-' +
        product?.productNumber +
        '-promotions-banner'
      "
    ></app-product-card-promotions-banner>
    <!-- style="flex: 1" -->
  </div>

  <div *ngIf="isMobile" class="mobile-details-section">
    <div class="mobile-header-section">
      <div class="mobile-section">
        <div class="listing">
          <span class="listing-key"
            >{{ 'i18n.lists.lastWeek' | translate }}:
          </span>
          <span data-cy="price-mode-sidebar-last-week">{{ lastWeek }}</span>
        </div>
        <div class="listing">
          <span class="listing-key">WWP: </span>
          <span data-cy="price-mode-sidebar-wwp">{{ wwp2 }}</span>
        </div>

        <div class="listing">
          <span class="listing-key"
            >{{ 'i18n.lists.targetDifference' | translate }}:
          </span>
          <span data-cy="price-mode-sidebar-target-difference">{{
            targetDifference
          }}</span>
        </div>
      </div>

      <div class="mobile-section">
        <div class="listing">
          <span class="listing-key"
            >{{ 'i18n.lists.lowLimit' | translate }}:
          </span>
          <span data-cy="price-mode-sidebar-low-limit">{{ lowLimit }}</span>
        </div>
        <div class="listing rationale-listing">
          <span class="listing-key rationale-key"
            >{{ 'i18n.lists.rationale' | translate }}:
          </span>
          <span data-cy="price-mode-sidebar-rationale">{{ rationale }}</span>
        </div>
      </div>
    </div>

    <div class="current-target-custom-section">
      <div class="current-week-section one-third-width">
        <div class="current-week-section-inner">
          <span>Current Week</span>
          <div class="current-price-value-container">
            <span
              class="current-week-price"
              data-cy="price-mode-sidebar-current-price"
              >{{ somePrice }}
              <!-- TODO: Don't forget to change the name of somePrice -->
            </span>
            <span
              class="current-week-price-change"
              data-cy="price-mode-sidebar-price-change"
            >
              {{ currentWeekPriceChange | currency }}
              <ng-container *ngIf="+currentWeekPriceChange > 0; else downArrow">
                <ion-icon name="arrow-up-circle" color="success"></ion-icon>
              </ng-container>
              <ng-template #downArrow>
                <ion-icon name="arrow-down-circle" color="success"></ion-icon>
              </ng-template>
            </span>
          </div>
        </div>
      </div>
      <div class="target-case-price-section one-third-width">
        <div class="target-case-price-section-inner">
          <span>{{ 'i18n.lists.targetCasePrice' | translate }}</span>
          <ion-button
            expand="block"
            fill="outline"
            class="target-price-button"
            [class.target-price-set]="targetCasePriceSet"
            (click)="setPriceTarget()"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-target-price'
            "
          >
            <ion-icon
              *ngIf="targetCasePriceSet"
              name="checkmark-circle"
              color="success"
              slot="start"
            ></ion-icon>
            {{ targetCasePrice }}
          </ion-button>
        </div>
      </div>
      <div class="custom-case-price-section one-third-width">
        <div class="custom-case-price-section-inner">
          <span>{{ 'i18n.lists.customCasePrice' | translate }}</span>
          <ion-item lines="none">
            <ion-input
              class="custom-case-price-input"
              aria-labelledby="file-name"
              id="custom-case-price-input"
              [(ngModel)]="customPrice"
              [attr.data-cy]="
                'price-mode-sidebar-product-' +
                product?.productNumber +
                '-custom-price'
              "
            ></ion-input>
          </ion-item>
          <!-- TO IMPLEMENT PRICING STATE-->
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isMobile" class="gpd-section">
    <div class="listing">
      <span class="listing-key">GPD: </span>
      <span data-cy="price-mode-sidebar-gpd">{{ gpd }}</span>
    </div>
    <div class="listing">
      <span class="listing-key">GPP: </span>
      <span data-cy="price-mode-sidebar-gpp">{{ gpp }}</span>
    </div>
    <div class="listing">
      <span class="listing-key"
        >{{ 'i18n.lists.marketChange' | translate }}:
      </span>
      <span data-cy="price-mode-sidebar-market-change">{{ marketChange }}</span>
    </div>
    <div class="listing">
      <span class="listing-key"
        >{{ 'i18n.lists.breakSurcharge' | translate }}:
      </span>
      <span data-cy="price-mode-sidebar-break-surcharge">{{
        breakSurcharge
      }}</span>
    </div>
    <div class="listing">
      <span class="listing-key">ASC: </span>
      <span data-cy="price-mode-sidebar-asc">{{ asc }}</span>
    </div>
    <div class="listing">
      <span class="listing-key"
        >{{ 'i18n.lists.eachPrice' | translate }}:
      </span>
      <span data-cy="price-mode-sidebar-each-price">{{ eachPrice }}</span>
    </div>
  </div>

  <div *ngIf="isMobile" class="gpd-section-mobile">
    <!-- left side -->
    <div class="mobile-section">
      <div class="listing">
        <span class="listing-key">GPD: </span>
        <span data-cy="price-mode-sidebar-gpd">{{ gpd }}</span>
      </div>
      <div class="listing">
        <span class="listing-key"
          >{{ 'i18n.lists.marketChange' | translate }}:
        </span>
        <span data-cy="price-mode-sidebar-market-change">{{
          marketChange
        }}</span>
      </div>
      <div class="listing">
        <span class="listing-key">ASC: </span>
        <span data-cy="price-mode-sidebar-asc">{{ asc }}</span>
      </div>
    </div>

    <!-- Right side -->
    <div class="mobile-section">
      <div class="listing">
        <span class="listing-key">GPP: </span>
        <span data-cy="price-mode-sidebar-gpp">{{ gpp }}</span>
      </div>
      <div class="listing">
        <span class="listing-key"
          >{{ 'i18n.lists.breakSurcharge' | translate }}:
        </span>
        <span data-cy="price-mode-sidebar-break-surcharge">{{
          breakSurcharge
        }}</span>
      </div>

      <div class="listing">
        <span class="listing-key"
          >{{ 'i18n.lists.eachPrice' | translate }}:
        </span>
        <span data-cy="price-mode-sidebar-each-price">{{ eachPrice }}</span>
      </div>
    </div>
  </div>

  <div class="last-4-buys-section">
    <span class="listing-key">{{ 'i18n.lists.last4Buys' | translate }}</span>
    <div class="grid-wrapper">
      <table>
        <tr>
          <th>{{ 'i18n.lists.invDate' | translate }}</th>
          <td
            *ngFor="let date of invDates.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-inv-date-' +
              i
            "
          >
            {{ date | date: 'M/d/yy' }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.invoices' | translate }}</th>
          <td
            *ngFor="let invoice of invoices.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-invoice-' +
              i
            "
          >
            {{ invoice }}
          </td>
        </tr>
        <tr>
          <th>WWP</th>
          <td
            *ngFor="let p of wwp.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-wwp-' +
              i
            "
          >
            {{ p }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.price' | translate }}</th>
          <td
            *ngFor="let price of prices.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-price-' +
              i
            "
          >
            {{ price }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.targetPercent' | translate }}</th>
          <td
            *ngFor="let percentage of targetPercents.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-target-percent-' +
              i
            "
          >
            {{ percentage }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.quantity' | translate }}</th>
          <td
            *ngFor="let qty of quantities.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-quantity-' +
              i
            "
          >
            {{ qty }}
          </td>
        </tr>
        <tr>
          <th>MTD</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.department' | translate }}</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr>
          <th>GPD</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr>
          <th>GPP</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
      </table>
    </div>
  </div>

  <div class="crp-section">
    <div class="listing">
      <span class="listing-key">{{
        'i18n.lists.approvedCPR' | translate
      }}</span>
      <span data-cy="price-mode-sidebar-approved-cpr">{{ approvedCPR }}</span>
    </div>
    <div class="listing">
      <span class="listing-key">{{
        'i18n.lists.approvedCPREnd' | translate
      }}</span>
      <span data-cy="price-mode-sidebar-approved-cpr-end">{{
        approvedCPREnd
      }}</span>
    </div>
    <div class="listing">
      <span class="listing-key">{{
        'i18n.lists.requestedCPR' | translate
      }}</span>
      <span data-cy="price-mode-sidebar-requested-cpr">{{ requestedCPR }}</span>
    </div>
    <div class="listing">
      <span class="listing-key">{{
        'i18n.lists.requestedCPRDate' | translate
      }}</span>
      <span data-cy="price-mode-sidebar-requested-cpr-date">{{
        requestedCPRDate
      }}</span>
    </div>
  </div>

  <div class="driver-section">
    <div class="listing">
      <span class="listing-key">{{ 'i18n.lists.driver' | translate }}</span>
      <span data-cy="price-mode-sidebar-driver-info"
        >{{ driverInfo }} ({{ driverNumber }})</span
      >
    </div>
  </div>
</div>
